
import EmptyWalletTick from "../../../assets/outline/EmptyWalletTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function EmptyWalletTickIcon({ className, dataTestid = "EmptyWalletTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <EmptyWalletTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
